module.exports = __webpack_public_path__ + "static/img/pensive.e5b6718.png";